import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { ClipLoader } from "react-spinners";
import validator from "validator";
import { resetPasswordAction } from "../redux/action/auth";
import { notify, notifyError } from "../helpers/helper";

function ResetPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.account);

  const params = new URLSearchParams(window.location.search);
  const account = params.get("account");
  const rs = params.get("rs");

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validate = (value) => {
    if (
      validator.isStrongPassword(value, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      setPasswordError("");
    } else {
      setPasswordError(
        "Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number and a special character"
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!account || !rs)
      return notifyError("Invalid or expired reset link. Please request a new one.");
    if (password === "") return setPasswordError("Please enter a new password");
    if (passwordError !== "") return;
    if (password !== confirmPassword)
      return setConfirmPasswordError("The passwords do not match");

    dispatch(
      resetPasswordAction(
        { account, rs, newPassword: password, confirmPassword },
        () => {
          notify("Password reset successfully. Please sign in.");
          navigate("/");
        }
      )
    );
  };

  const invalidLink = !account || !rs;

  return (
    <div className="auth-page">
      <div className="auth-from auth-from-wide">
        <div className="container">
          <div className="flex justify-center">
            <img src="/images/wasteknot_logo.png" alt="logo" className="logo" />
          </div>

          <h4 className="cercle-purple-text text-center">Reset Password</h4>

          {invalidLink ? (
            <>
              <div className="purple lighten-5 cercle-purple-text p-1 flex mt-1">
                <i className="material-symbols-outlined">error</i>
                <p className="ml-1">
                  This reset link is invalid or incomplete. Please request a new
                  one from the sign in page.
                </p>
              </div>
              <div className="mt-1 text-center">
                <Link to="/forgot-password" className="primary semi-bold">
                  Request a new link
                </Link>
              </div>
            </>
          ) : (
            <>
              <p className="grey-text text-center">
                Enter a new password for your account below.
              </p>

              <form className="mt-1" onSubmit={handleSubmit}>
                <div className="input-field-style">
                  <span className="material-symbols-outlined primary">lock</span>
                  <input
                    className="browser-default input-field"
                    placeholder="Enter your new password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      validate(e.target.value);
                    }}
                    required
                  />
                  <div
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ width: "25px" }}
                  >
                    {showPassword ? (
                      <AiFillEye className="eye-icon" />
                    ) : (
                      <AiFillEyeInvisible className="eye-icon" />
                    )}
                  </div>
                </div>
                {passwordError && (
                  <p className="small-text red-text">{passwordError}</p>
                )}

                <div className="input-field-style mt-1">
                  <span className="material-symbols-outlined primary">lock</span>
                  <input
                    className="browser-default input-field"
                    placeholder="Confirm your new password"
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setConfirmPasswordError("");
                    }}
                    required
                  />
                  <div
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{ width: "25px" }}
                  >
                    {showConfirmPassword ? (
                      <AiFillEye className="eye-icon" />
                    ) : (
                      <AiFillEyeInvisible className="eye-icon" />
                    )}
                  </div>
                </div>
                {confirmPasswordError && (
                  <p className="small-text red-text">{confirmPasswordError}</p>
                )}

                <div className="submit-btn mv-2 column flex align-center">
                  <button
                    className="btn full-width mb-1 mt-1"
                    type="submit"
                    disabled={
                      !password ||
                      !confirmPassword ||
                      passwordError !== "" ||
                      loading
                    }
                  >
                    {loading ? (
                      <ClipLoader color="#fff" size={20} />
                    ) : (
                      "Reset Password"
                    )}
                  </button>
                </div>
              </form>

              <div className="mt-1 text-center">
                <Link to="/" className="primary semi-bold">
                  Back to Sign In
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
